export default "__VITE_ASSET__0ce81716__"